
import { CharteSignatureFormContainer } from "./charte/CharteSignatureFormContainer";
import { CharteSignatureFormProps } from "./charte/types";

export const CharteSignatureForm = ({ onSuccess }: CharteSignatureFormProps) => {
  return <CharteSignatureFormContainer onSuccess={onSuccess} />;
};
